export const createHiddenInput = (
  element: HTMLElement,
  name: string,
  value: string,
  className?: string,
  dataAttribute?: string,
  dataAttributeValue?: string,
): void => {
  const input = document.createElement('input');

  input.type = 'hidden';
  input.name = name;
  input.value = value;

  if (className) {
    input.className = className;
  }

  if (dataAttribute && dataAttributeValue) {
    input.setAttribute(dataAttribute, dataAttributeValue);
  }

  element.appendChild(input);
};

/**
 * Resolves with the element once it is in the document, or with null after the timeout. Used by providers
 * whose container a React modal mounts on the same store update that starts them, so it may not be there yet.
 */
export const waitForElement = (id: string, timeoutMs: number): Promise<HTMLElement | null> =>
  new Promise((resolve) => {
    const found = document.getElementById(id);
    if (found) {
      resolve(found);

      return;
    }

    const observer = new MutationObserver(() => {
      const element = document.getElementById(id);
      if (element) {
        observer.disconnect();
        clearTimeout(timeoutId);
        resolve(element);
      }
    });
    const timeoutId = setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, timeoutMs);

    observer.observe(document.body, { childList: true, subtree: true });
  });
